function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.365433 0.365433C0.852677 -0.121811 1.64266 -0.121811 2.1299 0.365433L8.30554 6.54107C9.28003 7.51555 9.28003 9.09551 8.30554 10.07L0.365433 2.1299C-0.121811 1.64266 -0.121811 0.852677 0.365433 0.365433Z",
  fill: "#708390"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2455 0.365549C16.7327 0.852793 16.7327 1.64277 16.2455 2.13002L8.30554 10.07C7.33105 9.09551 7.33105 7.51555 8.30554 6.54107L14.481 0.365549C14.9682 -0.121695 15.7582 -0.121695 16.2455 0.365549Z",
  fill: "#708390"
});

var SvgNavDownIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNavDownIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/nav-down-icon.bf5d55e1.svg";
export { ForwardRef as ReactComponent };